module.exports = __webpack_public_path__ + "img/answer-c2-5.0a71e28c.png";